import { CrossButton } from 'components';
import { ArrowLeft } from 'lucide-react';
import React, { useState } from 'react';
import './addFund.css';
import { IoCopyOutline } from 'react-icons/io5';
import { FaRegCircleCheck } from 'react-icons/fa6';
import { FiRefreshCw } from 'react-icons/fi';
import toast from 'react-hot-toast';

const AddFundCanvas = ({ isOpen, closeModal, accountDetails }) => {
    const [copiedText, setCopiedText] = useState('');

    // Default account details if not provided
    const defaultDetails = {
        virtualAccount: {
            accountNumber: '1234567890123456',
            ifscCode: 'HDFC0001234'
        },
        transferDetails: {
            accountNumber: '345345345453',
            ifscCode: 'HDFC0001234',
            accountName: 'Eminence Infotech Pvt. Ltd.',
            bankName: 'ICICI Bank'
        }
    };

    const details = accountDetails || defaultDetails;

    // Copy to clipboard function
    const handleCopy = async (text, label) => {
        try {
            await navigator.clipboard.writeText(text);
            setCopiedText(text);
            toast.success(`${label} copied!`);
            
            // Reset copied state after 2 seconds
            setTimeout(() => {
                setCopiedText('');
            }, 2000);
        } catch (err) {
            console.error('Failed to copy:', err);
            
            // Fallback for older browsers
            try {
                const textArea = document.createElement('textarea');
                textArea.value = text;
                textArea.style.position = 'fixed';
                textArea.style.left = '-999999px';
                document.body.appendChild(textArea);
                textArea.select();
                document.execCommand('copy');
                textArea.remove();
                
                toast.success(`${label} copied!`);
                setCopiedText(text);
                setTimeout(() => setCopiedText(''), 2000);
            } catch (fallbackErr) {
                toast.error('Failed to copy');
            }
        }
    };

    return (
        <div
            className={`offcanvas offcanvas-end common_offCanvas ${isOpen ? "show" : ""}`}
            tabIndex={-1}
            style={{
                visibility: isOpen ? "visible" : "hidden",
            }}
        >
            {isOpen && (
                <>
                    <div className="offcanvas-header offcan_header">
                        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                            <button className='__backArrow_btn'
                                onClick={() => closeModal(false)}
                            >
                                <ArrowLeft size={20} color="#000" />
                            </button>
                            <h5 className="offcanvas-title">Add Funds</h5>
                        </div>

                        <CrossButton type="button" className="_switchBtn  __animEffect_btn" style={{ marginLeft: 'auto' }} onClick={closeModal}>
                            <svg className="cross" xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none" >
                                <path
                                    d="M12.5321 0.477671C12.4422 0.387555 12.3353 0.316061 12.2177 0.267281C12.1001 0.2185 11.9741 0.193391 11.8468 0.193391C11.7195 0.193391 11.5934 0.2185 11.4758 0.267281C11.3582 0.316061 11.2514 0.387555 11.1615 0.477671L6.40798 5.22143L1.6545 0.46795C1.56451 0.377952 1.45766 0.306563 1.34008 0.257857C1.22249 0.20915 1.09646 0.184082 0.969185 0.184082C0.84191 0.184082 0.715881 0.20915 0.598294 0.257857C0.480707 0.306563 0.373865 0.377952 0.283868 0.46795C0.19387 0.557947 0.122481 0.664789 0.0737746 0.782376C0.0250685 0.899963 -9.48274e-10 1.02599 0 1.15327C9.48275e-10 1.28054 0.0250684 1.40657 0.0737746 1.52416C0.122481 1.64175 0.19387 1.74859 0.283868 1.83858L5.03735 6.59206L0.283868 11.3455C0.19387 11.4355 0.122481 11.5424 0.0737746 11.66C0.0250685 11.7776 0 11.9036 0 12.0309C0 12.1581 0.0250685 12.2842 0.0737746 12.4017C0.122481 12.5193 0.19387 12.6262 0.283868 12.7162C0.373865 12.8062 0.480707 12.8776 0.598294 12.9263C0.715881 12.975 0.84191 13 0.969185 13C1.09646 13 1.22249 12.975 1.34008 12.9263C1.45766 12.8776 1.56451 12.8062 1.6545 12.7162L6.40798 7.9627L11.1615 12.7162C11.2515 12.8062 11.3583 12.8776 11.4759 12.9263C11.5935 12.975 11.7195 13 11.8468 13C11.974 13 12.1001 12.975 12.2177 12.9263C12.3353 12.8776 12.4421 12.8062 12.5321 12.7162C12.6221 12.6262 12.6935 12.5193 12.7422 12.4017C12.7909 12.2842 12.816 12.1581 12.816 12.0309C12.816 11.9036 12.7909 11.7776 12.7422 11.66C12.6935 11.5424 12.6221 11.4355 12.5321 11.3455L7.77861 6.59206L12.5321 1.83858C12.9015 1.46919 12.9015 0.847062 12.5321 0.477671Z"
                                    fill="black"
                                />
                            </svg>
                        </CrossButton>
                    </div>

                    <div className="offcanvas-body">
                        <div className="af-container">
                            {/* Top Card */}
                            <div className="af-card af-white">
                                <h3 className="af-title">Add funds to your virtual account</h3>

                                <div className="af-field">
                                    <div className="af-copy">
                                        <div>
                                            <label>Account Number</label>
                                            <span>{details.virtualAccount.accountNumber}</span>
                                        </div>
                                        <button 
                                            className={`__copyBtn ${copiedText === details.virtualAccount.accountNumber ? 'copied' : ''}`}
                                            onClick={() => handleCopy(details.virtualAccount.accountNumber, 'Account Number')}
                                            aria-label="Copy account number"
                                        >
                                            <IoCopyOutline />
                                        </button>
                                    </div>
                                </div>

                                <div className="af-field">
                                    <div className="af-copy">
                                        <div>
                                            <label>IFSC Code</label>
                                            <span>{details.virtualAccount.ifscCode}</span>
                                        </div>
                                        <button 
                                            className={`__copyBtn ${copiedText === details.virtualAccount.ifscCode ? 'copied' : ''}`}
                                            onClick={() => handleCopy(details.virtualAccount.ifscCode, 'IFSC Code')}
                                            aria-label="Copy IFSC code"
                                        >
                                            <IoCopyOutline />
                                        </button>
                                    </div>
                                </div>
                            </div>

                            {/* How to Add Funds */}
                            <div className="af-card af-blue">
                                <h4 className="af-subtitle">How to add funds</h4>

                                <div className='af-step-bxs'>
                                    <div className='af-stepOtr'>
                                        <div className="af-step">
                                            <div className="af-step-number">1</div>
                                            <div className="af-step-content">
                                                <strong>Transfer from your Bank Account</strong>
                                            </div>
                                        </div>
                                        <div className="af-info-box">
                                            <div className="af-row">
                                                <div>
                                                    <label>Account Number</label>
                                                    <span>{details.transferDetails.accountNumber}</span>
                                                </div>
                                                <button 
                                                    className={`__copyBtn ${copiedText === details.transferDetails.accountNumber ? 'copied' : ''}`}
                                                    onClick={() => handleCopy(details.transferDetails.accountNumber, 'Account Number')}
                                                >
                                                    <IoCopyOutline />
                                                </button>
                                            </div>

                                            <div className="af-row">
                                                <div>
                                                    <label>IFSC Code</label>
                                                    <span>{details.transferDetails.ifscCode}</span>
                                                </div>
                                                <button 
                                                    className={`__copyBtn ${copiedText === details.transferDetails.ifscCode ? 'copied' : ''}`}
                                                    onClick={() => handleCopy(details.transferDetails.ifscCode, 'IFSC Code')}
                                                >
                                                    <IoCopyOutline />
                                                </button>
                                            </div>

                                            <div className="af-row">
                                                <div>
                                                    <label>Account Name</label>
                                                    <span>{details.transferDetails.accountName}</span>
                                                </div>
                                                <button 
                                                    className={`__copyBtn ${copiedText === details.transferDetails.accountName ? 'copied' : ''}`}
                                                    onClick={() => handleCopy(details.transferDetails.accountName, 'Account Name')}
                                                >
                                                    <IoCopyOutline />
                                                </button>
                                            </div>

                                            <div className="af-row">
                                                <div>
                                                    <label>Bank</label>
                                                    <span>{details.transferDetails.bankName}</span>
                                                </div>
                                                <button 
                                                    className={`__copyBtn ${copiedText === details.transferDetails.bankName ? 'copied' : ''}`}
                                                    onClick={() => handleCopy(details.transferDetails.bankName, 'Bank Name')}
                                                >
                                                    <IoCopyOutline />
                                                </button>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='af-stepOtr'>
                                        <div className="af-step">
                                            <div className="af-step-number">2</div>
                                            <div className="af-step-content">
                                                <strong>Instant Credit</strong>
                                                <p>Funds credited within 30 minutes</p>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='af-stepOtr'>
                                        <div className="af-step">
                                            <div className="af-step-number">3</div>
                                            <div className="af-step-content">
                                                <strong>Get Notified</strong>
                                                <p>Receive confirmation once amount is added</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Safe & Secure */}
                            <div className="af-card af-green">
                                <div className="af-safeSecure">
                                    <div className="af-icon">
                                        <FaRegCircleCheck />
                                    </div>
                                    <div className="af-safeContent">
                                        <span>Safe & Secure</span>
                                        <p>
                                            All transactions are encrypted with bank-grade security.
                                            Your funds will be instantly reflected in your wallet balance.
                                        </p>
                                    </div>
                                </div>
                            </div>

                            {/* Bottom Stats */}
                            <div className="af-stats">
                                <div className="af-stat af-refreshStat">
                                    <div className='af-icon'><FiRefreshCw /></div>
                                    <div>
                                        <p>Credit Time</p>
                                        <strong>30 mins</strong>
                                    </div>
                                </div>

                                <div className="af-stat">
                                    <div className='af-icon'><FaRegCircleCheck /></div>
                                    <div>
                                        <p>Success Rate</p>
                                        <strong>99.9%</strong>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}
        </div>
    );
};

export default AddFundCanvas;

// USAGE EXAMPLE:
// const accountData = {
//   virtualAccount: {
//     accountNumber: '9876543210987654',
//     ifscCode: 'ICIC0001234'
//   },
//   transferDetails: {
//     accountNumber: '1234567890123',
//     ifscCode: 'HDFC0001234',
//     accountName: 'Your Company Name',
//     bankName: 'HDFC Bank'
//   }
// };
//
// <AddFundCanvas 
//   isOpen={showAddFund} 
//   closeModal={() => setShowAddFund(false)}
//   accountDetails={accountData}
// />